import styled from 'styled-components';

export const Dot = styled.div<{ $bg: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ $bg }) => $bg};
`;
